function Fiberoptic() {
    return(
        <>
        <div className="container-fluid pt-5 hero-header mb-5">
  <div className="slider-container">
    <div className="slide2">
      <div className="container pt-5">
        <div className="row g-5 pt-5">
          <div className="col-lg-8 align-self-center text-center text-lg-start mb-lg-5">
            <h1 className="display-6 text-white mb-1 animated slideInRight">
            Fiber Optic
            </h1>
            <nav aria-label="breadcrumb">
  <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
    <li className="breadcrumb-item">
      <a className="text-white" href="/">
        Home
      </a>
    </li>
    <li className="breadcrumb-item">
      <a className="text-white" href="/solutions">
        Solutions
      </a>
    </li>
    <li className="breadcrumb-item text-white active" aria-current="page">
      Fiber Optic
    </li>
  </ol>
</nav>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
        <div className="container-fluid py-5">
  <div className="container">
    <div className="row g-5 align-items-center">
      <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
        <div className="about-img about-img-cont">
          <img
            className="img-fluid"
            src="img/futuristic-computer-network-connects-global-industry-modern-warehouse-generated-by-artificial-intelligence.jpg"
            alt=""
          />
        </div>
        <div className="box green" />
      </div>
      <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
        <div className="btn btn-sm border rounded-pill text-warningS px-3 mb-3">
        Fiber Optic
        </div>
        <h1 className="mb-4">
          RScom Network{" "}
          <span className="more-about-us-home">
            - Leading Provider of Flexible Network Infrastructure Solutions
          </span>
        </h1>
        <p className="mb-4">
          RScom Network specializes in delivering customer-centric design and
          adaptable network physical infrastructure solutions across diverse
          sectors. Our comprehensive range of fiber optics, copper, and rack
          systems caters to the unique demands of Data Centers, Enterprise
          Networks, Transportation Networks, Broadcast and CATV Networks, as
          well as Telecom and FTTx sectors.
        </p>
        <p className="mb-4">
        Our expert staff with more than ten years of experience in
the industry is dedicated to providing you with professional
knowledge that meets your market needs.
        </p>
        <p className="md-4">Rscomnetworking develops superior products and solutions in close collaboration with customers, meeting the
legal and regulatory requirements of products and meeting
the needs of customers and other stakeholders. Our structured cabling and modular racking system can be used
as a fully integrated solution or can be flexibly adapted to
other or partially compatible solutions. With our customer-focused focus, our flexible solutions help you greatly
improve cost structure and increase asset utilization. With
rscom, it helps you expand your revenue opportunities by
reducing TCO (Total Cost of Ownership) and achieving a
www
WHO WE ARE
better ROI.</p>
        <div className="row g-3">
          <div className="col-sm-6">
            <h6 className="mb-3">
              <i className="fa fa-check text-warningS me-2" />
              Recognized for Excellence
            </h6>
            <h6 className="mb-0">
              <i className="fa fa-check text-warningS me-2" />
              Highly Skilled Professionals
            </h6>
          </div>
          <div className="col-sm-6">
            <h6 className="mb-3">
              <i className="fa fa-check text-warningS me-2" />
              24/7 Dedicated Support
            </h6>
            <h6 className="mb-0">
              <i className="fa fa-check text-warningS me-2" />
              Competitive Pricing
            </h6>
          </div>
        </div>
        <div className="d-flex align-items-center mt-4">
          <a className="btn btn-warningS rounded-pill px-4 me-3" href="Rscom_datasheet.pdf">
            Read PDF
          </a>
          <button className="btn btn-outline-warningS btn-square me-3" type="button">
  <i className="fab fa-facebook-f" />
</button>
<button className="btn btn-outline-warningS btn-square me-3" type="button">
            <i className="fab fa-twitter" />
            </button>
            <button className="btn btn-outline-warningS btn-square me-3" type="button">
            <i className="fab fa-instagram" />
            </button>
            <button className="btn btn-outline-warningS btn-square me-3" type="button">
            <i className="fab fa-linkedin-in" />
            </button>
        </div>
      </div>
    </div>
  </div>
</div></>
    )
}

export default Fiberoptic;